<template>
  <div class="nav">
    <ul>
      <li class="phone" v-if="kfObj.KefuTelList && kfObj.KefuTelList[0]">
        <p>咨询电话：</p>
        <p>000000</p>
      </li>
      <li v-if="kfObj.KefuQQList && kfObj.KefuQQList[0] && kfObj.KefuQQList[0].KefuNumber">
        <a :href="'http://wpa.qq.com/msgrd?v=3&amp;uin=' + kfObj.KefuQQList[0].KefuNumber + '&amp;site=qq&amp;menu=yes'" target="_blank">QQ咨询</a>
      </li>
      <li @click="scrollTo('welfare')" v-if="visibilit.welfare">红包福利</li>
      <li @click="scrollTo('spell')" v-if="visibilit.spell">拼团特惠</li>
      <li @click="scrollTo('hot')" v-if="visibilit.hot">限时爆款</li>
      <li @click="scrollTo('good')" v-if="visibilit.good">好课快抢</li>
      <li @click="scrollTo('rule')" v-if="visibilit.rule">活动规则</li>
      <li><a href="/shopping">购课车<label v-if="num">{{num > 9 ? "9+" : num}}</label></a></li>
    </ul>
    <img src="https://img2.233.com/wx/union/618/2021/pc/fix-nav-top.png" @click="backTop">
  </div>
</template>

<script>
import { GetEcartCount, GetKeFuByHost } from "../../../lib/request"
export default {
  name: "Welfare",
  props: {
    visibilit: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      num: 0,
      kfObj: {}
    }
  },
  created() {
    this.GetEcartCount()
    this.GetKeFuByHost()
  },
  methods: {
    GetEcartCount() {
      GetEcartCount({}, (res) => {
        this.num = res.Result || 0
      })
    },
    GetKeFuByHost() {
      GetKeFuByHost({}, (res) => {
        if (!res.ResultDescription) {
          this.kfObj = res.Result
        }
      })
    },
    scrollTo(name) {
      if (name === "welfare" || name === "spell" || name === "hot") {
        this.$emit("updateFixed")
      }
      const htmlScrollTop = document.querySelector("body").scrollTop
      const scrollDom = document.querySelector(htmlScrollTop === 0 ? "html" : "body")
      const mealTop = document.querySelector("." + name).getBoundingClientRect().top
      scrollDom.scrollTop = scrollDom.scrollTop + mealTop
    },
    backTop() {
      const htmlScrollTop = document.querySelector("html").scrollTop
      const scrollDom = document.querySelector(htmlScrollTop === 0 ? "body" : "html")
      scrollDom.style.marginTop = -scrollDom.scrollTop + 'px'
      scrollDom.scrollTop = 0
      scrollDom.style.transition = 'all .5s ease-in-out'
      scrollDom.style.marginTop = 0
      setTimeout(() => {
        scrollDom.style.transition = 'none'
        this.$emit("updateFixed")
      }, 500)
    }
  }
}
</script>

<style lang="scss" scoped>
.nav{
  position: fixed;
  right: 3%;
  top: 12%;
  width: 146px;
  z-index: 9;
  ul{
    background: rgba($color: #2B3892, $alpha: 0.8);
    padding: 8px 6px 0 7px;
    li{
      height: 38px;
      line-height: 38px;
      // background: linear-gradient(270deg, #E3332F 0%, #EC683F 100%);
      background: linear-gradient(-90deg, #3945B9 0%, #3C65CE 100%);
      font-size: 16px;
      color: #fff;
      font-weight: 400;
      margin-bottom: 8px;
      list-style: none;
      text-align: center;
      cursor: pointer;
      &:nth-last-child(1){
        margin-bottom: 0;
      }
      &:hover{
        // background: linear-gradient(90deg, #FFE2AB 0%, #FFE8C5 100%);
        // color: #D41F1F;
        // label{
        //   background: #D41F1F;
        //   color: #fff;
        // }
        // a{
        //   color: #D41F1F;
        // }
      }
      p{
        font-size: 16px;
        line-height: 21px;
      }
      label{
        display: inline-block;
        padding: 0 4px;
        height: 14px;
        line-height: 14px;
        background: #fff;
        border-radius: 7px;
        font-size: 12px;
        color: #E43B31;
        margin: 10px 0 0 4px;
        vertical-align: top;
      }
      a{
        display: inline-block;
        width: 100%;
        height: 100%;
        text-decoration: none;
        color: #fff;
      }
    }
    .phone{
      // background: linear-gradient(-90deg, #758ED6, #0F559D);
      display: flex;
      justify-content: center;
      flex-direction: column;
      box-sizing: border-box;
      font-weight: bold;
      background: url('https://img2.233.com/wx/union/618/2021/pc/fix-nav-sel.png') no-repeat;
      width: 100%;
      height: 58px;
      background-size: cover;
      // border-right: 3px solid #FFC452;
    }
  }
  img{
    vertical-align: top;
    cursor: pointer;
  }
}
</style>